export default {
  name: 'CauPlaidLinkScreen',
  props: {
    fromApp: {
      type: Boolean,
      default: false
    },
    canLinkOnWeb: {
      type: Boolean,
      default: true
    },
    plaidProcessing: {
      type: Boolean,
      default: false
    },
    plaidError: {
      type: String,
      default: ''
    }
  }
};